import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { getStore } from '../../../../common/redux/store-utils';

import SendPasswordPanel from './components/Panel';
import AuthScreenLayout from '../../components/AuthScreenLayout';

import { isSupportedBrowser } from '../../common/utils';
import UnsupportedBrowsers from '../../components/UnsupportedBrowsers';

const store = getStore();

const createSendPasswordScreen = () => {
  const domId = 'sendPasswordPanel';
  if (isSupportedBrowser()) {
    ReactDOM.render(
      <Provider store={store}>
        <AuthScreenLayout>
          <SendPasswordPanel />
        </AuthScreenLayout>
      </Provider>,
      document.getElementById(domId)
    );
  } else {
    ReactDOM.render(<UnsupportedBrowsers />, document.getElementById(domId));
  }
};

window.createSendPasswordScreen = createSendPasswordScreen;
